(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/difference', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/difference'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.difference, global.convert);
    global.difference = mod.exports;
  }
})(this, function (exports, _difference2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.difference = undefined;

  var _difference3 = _interopRequireDefault(_difference2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces an array removing values in the other given arrays from the former array.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {...Array} values The arrays of values to exclude.
   * @return {Object} Returns the updated object.
   * @example difference({ nested: { prop: [1, 2] } }, 'nested.prop', [2, 3]) // => { nested: { prop: [1] } }
   * @see {@link https://lodash.com/docs#difference|lodash.difference} for more information.
   * @since 0.2.0
   */
  var difference = (0, _convert.convert)(_difference3.default);
  exports.difference = difference;
  exports.default = difference;
});